export enum RoutePaths {
    AnimalAnnouncements = '/animals/animal-announcements-list-view',
    AnimalsList = '/animals/list',
    AnimalsProductionPlans = '/animals/productionplans',
    AnimalsPayloads = '/animals/payloads',
    AnimalBreeding = '/animal/breedings',
    Contracts = '/contracts',
    DocumentsInfo = '/documents/info',
    DocumentsNews = '/documents/news',
    EconomyAccountings = '/economy/accountings',
    EconomyInvoices = '/economy/invoices',
    EconomyPriceList = '/economy/pricelist',
    EconomyTaxYearSummary = '/economy/tax-year-summary',
    FarmDocuments = '/farm-files',
    FarmVisitDialogEdit = '/farm-visit/edit',
    GeneralCalendar = '/calendar',
    GeneralContacts = '/contacts',
    GeneralDashboard = '/dashboard',
    GeneralFarmInfo = '/farm-info',
    GeneralFarmVisits = '/farm-visit',
    GeneralFeedback = '/feedback',
    GeneralMessaging = '/messages',
    GeneralMyInfo = '/my-info',
    InfoFeeding = '/info/feeding',
    InfoShop = '/info/shop',
    InfoInstructionsAndCode = '/info/instructions',
    InfoLab = '/info/lab',
    InfoMP = '/info/mp',
    InvoiceDetailView = '/invoice',
    ManagementAccessRights = '/management/access-rights',
    ManagementBulletin = '/management/bulletin',
    ManagementCompanySearch = '/management/company-search',
    ManagementContentEditor = '/management/content',
    ManagementEvents = '/management/events',
    ManagementEventAttendees = '/management/event-attendees/:eventId',
    ManagementLogs = '/management/logs',
    ManagementPersonSearch = '/management/person-search',
    ManagementSearchParameters = '/management/search-parameters',
    ManagementShortMessageService = '/management/sms',
    ManagementSlaughterVariables = '/management/slaughter-variables',
    ConversationDialogEdit = '/messages/conversation/edit',
    PrivacyStatement = '/privacy-statement',
    PublicMPBovine = '/mp/bovine',
    PublicMPPork = '/mp/pork',
    ProductionPlanDialogRoot = '/production-plan/create',
    ReportingButchery = '/reporting/butchery',
    ReportingFinancial = '/reporting/financial',
    ReportingHealth = '/reporting/health',
    ReportingProduction = '/reporting/production',
    ResourceManagement = '/Resources/Management',
    FeedbackEdit = '/feedback/edit',
    BovinePurchaseEdit = '/animals/bovine-purchase-announcement/edit',
    BovineSlaughterEdit = '/animals/bovine-slaughter-announcement/edit',
    BovineIntermediationEdit = '/animals/bovine-intermediation-announcement/edit',
    Root = '/',
}

export enum AddressTypeEnum {
    HoldingSite = 3,
    Postal = 2,
    Street = 1,
}

export enum AliasTypeEnum {
    BankAccount = 7,
    Context = 9,
    FarmId = 3,
    ProducerNumber = 6,
}

export enum AnimalFilterTypeEnum {
    WaitingRoom = 0,
    Cow = 1,
    Heifer = 2,
    Bull = 3,
    Sales = 4,
    Calvings = 5,
    Naseva = 6,
    Deceased = 7,
    All = 99,
}

export enum AnimalTypeEnum {
    Unknown = 0,
    Bovine = 1,
    Pork = 2,
}

export enum ProductionPlanAnimalType {
    Unknown = 0,
    DairyCow, // Lypsylehmät
    BreedingCow, // Emolehmät
    Bull, // Sonnit
    Heifer, // Hiehot
    Calf, // Vasikat
    FirstMilkBullCalf, // Ternivasikat sonnit
    FirstMilkCowCalf, // Ternivasikat lehmät
    TransmissionBullCalf, // Välitysvasikat sonnit
    TransmissionCowCalf, // Välitysvasikat lehmät
    IntergrowBullCalf, // Välikasvatetut vasikat sonnit
    IntergrowCowCalf, // Välikasvatetut vasikat lehmät
    BeefBullCalf, // Pihvivasikat sonnit
    BeefCowCalf, // Pihvivasikat lehmät
    BeefCow, // Teurasnauta-lehmä
    BeefBull, // Teurasnauta-sonni
    BeefHeifer, // Teurasnauta-hieho
    SlaughterBeefBull, // Pihvisonni
    SlaughterBeefHeifer, // Pihvihieho
}

export enum AnnouncementTypeEnum {
    Slaughter = 1,
    Intermediation = 2,
    BovinePurchase = 3,
    ManualBovineSlaughter = 4,
    ManualBovineIntermediation = 5,
    SlaughterWithChainInformation = 6,
    PreliminaryBovineSlaughterAnnouncement = 7,
    PreliminaryBovineIntermediationAnnouncement = 8,
    PreliminaryBovinePurchaseAnnouncement = 9,
}

export enum BusinessCodeTypeEnum {
    Company = 1,
}

export enum BusinessFormTypeEnum {
    CommercialName = 3,
    Corporation = 1,
    FarmingConsortium = 5,
    GeneralPartnership = 4,
    LimitedPartnership = 2,
}

export enum CarCapacityTypeEnum {
    Bovines = 1,
    Calves = 2,
    Piglets = 4,
    Pigs = 3,
}

export enum AnnouncementListDataGridColumnType {
    Default = 1,
    BovineIntermediation = 2,
    BovinePurchase = 3,
}

export enum UserDataEntityTypeEnum {
    FarmContext = 'FarmContext',
    CompanyContext = 'CompanyContext',
}

export enum CarouselBoxTypeEnum {
    WaitingStatus = 1,
    Cow = 2,
    Heifer = 3,
    Bull = 4,
    SaleAnnouncement = 5,
    CalfOrder = 6,
    AllAnimals = 7,
    Deceased = 8,
}

export enum FarmingTypeEnum {
    Calving = 1,
    CombinationProduction = 6,
    Dairy = 2,
    Piggery = 7,
    PigletProduction = 5,
    Processing = 8,
    Transmission = 4,
    Upbringing = 3,
}

export enum CompanyEntityTypeEnum {
    Farm = 6,
    Snellman = 10,
    TrafficContractor = 7,
    Unknown = 0,
}

export enum CompanyNameTypeEnum {
    Primary = 1,
}

export enum ContactPersonTypeEnum {
    Unknown = 0,
}

export enum ContactPersonRoleTypeEnum {
    Unknown = 0,
}

export enum PhoneNumberTypeEnum {
    CompanyPayloadAndCollection = 54,
    CompanyOffice = 50,
    CompanySMS = 51,
    PersonHome = 52,
    PersonWork = 53,
}

export enum BovineFarmingType {
    Unknown = 0,
    Beef = 1,
    Dairy = 2,
    Breeding = 3,
    Transmission = 4,
}

export enum DialogModeEnum {
    Create = 'create',
    Edit = 'edit',
}

export enum CollectWeekDayEnum {
    WholeWeek = 1,
    EarlyWeek = 2,
    EndOfWeek = 3,
    Monday = 4,
    Tuesday = 5,
    Wednesday = 6,
    Thursday = 7,
    Friday = 8,
    Saturday = 9,
    Sunday = 10,
}

export enum AnelmaReportTypeEnum {
    FinancialReport = 'FinancialReport',
    ProductionReport = 'ProductionReport',
    HealthReport = 'HealthReport',
    SlaughterReport = 'SlaughterReport',
    TaxYearSummaryReport = 'TaxYearSummaryReport',
}

export enum AnelmaReportingBtnGroupNameEnum {
    FinancialReport = 'FinancialReportRadioBtnGroup',
    ProductionReport = 'ProductionReportRadioBtnGroup',
    HealthReport = 'HealthReportRadioBtnGroup',
    SlaughterReport = 'SlaughterReportBtnGroup',
}

export enum AnelmaEnvironment {
    Development = 'development',
    Test = 'test',
    Production = 'production',
}

export enum InfoSectionType {
    InfoSection = 1,
    InfoSectionsGmFree = 2,
}

export enum InfoSections {
    general = 'general',
    bovine = 'bovine',
    pork = 'pork',
    anelmaInfo = 'anelmainfo', //Params -> AnelmaInstructions:InfoSections code anelmainfo
}

export enum InfoSectionsGmFree {
    general = '1',
    bovine = '2',
    pork = '3',
}

export enum InfoSectionsNews {
    general = '1',
    bovine = '2',
    magazineArchive = '3',
}

export enum RoleFilterEnum {
    InternalOnly = 0,
    ProducerOnly = 1,
    All = 99,
}

export enum ProductionPlanType {
    Draft = 1,
    Completed,
    Approved,
}

export enum ProductionLineType {
    Bovine = 1,
    Pork,
}

export enum OrganicProductionState {
    None = 0,
    FieldsOnly,
    FieldsAndBovine,
    TransitionPhase,
}

export enum ProductionPlanQuestionType {
    Unknown = 0,
    Boolean,
    MultiSelect,
    Text,
    SingleSelect,
    Number,
}

export enum AnimalListButtonsEnum {
    Groups = 1,
    NewSlaughterAnnouncement = 2,
    NewIntermediationAnnouncement = 3,
    NewPurchaseAnnouncement = 4,
    SalesType = 5,
    BovineRegisterLink = 6,
    CarcassNet = 7,
    ManualAnnouncements = 8,
    ReclamationFeedback = 9,
}

export enum SalesType {
    Undefined = 0,
    IsoLihasika = 10,
    Lihasika = 11,
    Emakko = 12,
    Jalostuskarju = 13,
    Panssarikarju = 14,
    Salakarju = 15,
    Karju = 16,
    NyljettySika = 17,
    NyljettyEmakko = 18,
    Pikkuvasikka = 20,
    Ruohovasikka = 21,
    Mulli = 22,
    Sonni = 23,
    Hieho = 24,
    Lehmä = 25,
    RistTaiRotusonni = 26,
    Nuorilehmä = 27,
    Pikalehmä = 28,
    Karitsa = 30,
    Lammas = 31,
    PorsasOmaSiirto = 32,
    PikkuporsasOmaSiirto = 33,
    LimSonniAlaCarte = 34,
    LimHiehoAlaCarte = 35,
    Pihvisonni = 36,
    Pihvihieho = 37,
    KoeporsasKarju = 40,
    KoeporsasImisä = 41,
    Pikkuporsas = 45,
    Hirvi = 50,
    Hevonen = 51,
    MUsiitoskarju = 52,
    PihSovas75prossa = 53,
    PihLevas75prossa = 54,
    LimSoVasAlaCarte = 55,
    LimLeVasAlaCarte = 56,
    Välitysporsas = 60,
    Sonnivasikka = 61,
    Lehmävasikka = 62,
    Ternisonnivas = 63,
    Ternilehmavas = 64,
    VälikasvSoVas = 65,
    VälikasvLeVas = 66,
    KantavaSiitoshieho = 67,
    VälitysporsasSek = 68,
    Koeporsas = 69,
    MASiitoskarju = 70,
    MASiitosensikko = 71,
    Siitossonni = 72,
    Siitoshieho = 73,
    MASiitosporsas = 74,
    Siitoslehmä = 75,
    MATiineSiitosensikko = 76,
}

export enum ProducerReturnOptionResourceText {
    selectedCarcassOption = 0,
    insideBeef = 1008,
    roastBeef = 1009,
    outsideBeef = 1010,
    cornerBeef = 1011,
    insideFillet = 1012,
    outsideFillet = 1013,
    entrecote = 1014,
    shankMeat = 1015,
    flankSteak = 1016,
    ribs = 1017,
    breastOrBrisket = 1032,
    lapBeef = 1018,
    frontPartOfBack = 1019,
    bones = 1020,
    fat = 1021,
}

// Copied from back-end QuestionResourceText.cs
export enum QuestionResourceText {
    //En myy välityseläimiä - yes/no
    NoTransmissionBovineSold = 1064,
    //En myy teurasnautoja - yes/no
    NoSlaughterBovineSold = 1065,
    //Lehmät ovat pihatossa - yes/no
    CowsAreInCowshed = 1023,
    //Olen kasvattajaosuuskunta Limousinin jäsen - yes/no
    LimousineMembershipExists = 1024,
    //Haluan tilitykseni paperilla - yes/no
    PrintedClearanceRequested = 1026,
    //Tilani on luomutuotannossa - yes/no + yhden vaihtoehdon valinta
    OrganicFarmingPerformed = 1027,
    //OrganicFarmingPerformedAdditionalParameter = 1027, // the same
    //Ostan vasikoita suoraan tiloilta - yes/no
    BuysCalfsDirectlyFromOtherFarm = 1033,
    //+ “Olen varmistanut GM-vapauden“ - yes/no per maatila
    GMFreedomValidated = 1037,
    //+ “Olen varmistanut EUn metsäkatoasetuksen…“ - yes/no per maatila
    ForestCutValidated = 1095,
    //Tilallamme on voimassa oleva salmonellavakuutus nautakarjalle - yes/no
    HasSalmonellaInsurance = 1031,
    //Tilamme teuraaksi kasvatettavilla nuorilla naudoilla on pehmeä makuualusta - yes/no
    SoftSleepingPad = 1087,
    //Suunnittelen eläinmäärää lisäävää investointia vuodelle - numero (vuosi)
    PlanToIncreaseAnimalAmount = 1096,
    //Nurmisato kg KA/ha - numero
    YearlyLawnCropAmount = 1043,
    //Olen sitoutunut ympäristötuen ehtoihin - yes/no
    CommittedToEnviromentalSupportConditions = 1044,
    //Tuotan biokaasua - yes/no
    IsBiogasProducer = 1045,
    //Tuotan aurinkoenergiaa - yes/no
    IsSolarPowerProducer = 1046,
    //Tuotan tuulivoimaa - yes/no
    IsWindPowerProducer = 1047,
    //Lisätietoa tuotantosuunnitelmaan - teksti
    AdditionalInfo = 1048,
    //Lopetan tuotannon vuonna - numero (vuosi)
    ProductionEndYear = 1080,
}

// Copied from parameter resource AnelmaCalendar:CalendarEventTypes, using from couple of TS classes so cannot use t function hooks in there
export enum CalendarEventTypes {
    PickupSlaughterAnimal = 1,
    PickupTransMissionAnimal = 2,
    FarmVisit = 3,
    Event = 4,
    EventRegistration = 5,
    OwnBookings = 6,
    Other = 7,
    ReligiousHolidays = 8,
}

export enum ReportStatus {
    Loading = 'loading',
    Ready = 'ready',
    Failed = 'failed',
}

export enum EventDialogMode {
    Save = 'save',
    Edit = 'edit',
    Delete = 'delete',
}

export enum ProductionPlanNotificationQueryParamOptions {
    ProductionPlanCompleted = 1,
    ProductionPlanStart = 2,
}

/** Emulates AnelmaCommunication:CommunicationSubject parameter. Please, make any changes also to Snellman.Messaging.API.Domain.Enums.Common.CommunicationSubjectEnum */
export enum CommunicationSubjectEnum {
    AccountingAndInvoicing = 1,
    FeedbackAboutAnelma = 2,
    ProductionMonitoring = 3,
    CompensationRequest = 4,
    AnimalAnnouncement = 5,
    SlaughterInformation = 6,
    TransportProducer = 7,
    Reporting = 8,
    Other = 9,
    TransportOperator = 10,
}

/** Emulates AnelmaCommunication:CommunicationStatus. Please, make any changes also to Snellman.Messaging.API.Domain.Enums.Common.CommunicationStatusEnum */
export enum CommunicationStatusEnum {
    Waiting = 1,
    Processing = 2,
    Processed = 3,
    Paid = 4,
}

/** Enumeration that emulates participant's type. Please, make any changes also to Snellman.Messaging.API.Domain.Enums.Feedback.FeedbackParticipantRoleEnum  */
export enum FeedbackParticipantRoleEnum {
    Handler = 1,
    Participant = 2,
    OriginalSender = 3,
}

/** Enumeration that emulates read type. Please, make any changes also to Snellman.Messaging.API.Domain.Enums.Common.ReadTypeEnum */
export enum ReadTypeEnum {
    NotRead = 1,
    Read = 2,
}

/** Enumeration that emulates feedback command type. Please, manke any changes also to Snellman.Messaging.API.Domain.Enums.Feedback.FeedbackCommandTypeEnum */
export enum FeedbackCommandEnum {
    CreateFeedbackProducer = 1,
    CreateFeedbackAdmin = 2,
    CreateReclamationFeedbackProducer = 3,
    CreateReclamationFeedbackAdmin = 4,
    CreatePayloadFeedbackProducer = 5,
    CreatePayloadFeedbackAdmin = 6,
}

/** Emulates AnelmaCommunication:CommunicationReason. Please, make any changes also to Snellman.Messaging.API.Domain.Enums.Common.CommunicationReasonEnum */
export enum CommunicationReasonEnum {
    Dead = 1,
    KilledIllness = 2,
    KilledFootDefect = 3,
    KilledWeakling = 4,
    KilledHernia = 5,
    KilledOther = 6,
    Medication = 7,
    KilledRespiratoryTractInfection = 8,
    KilledDiarrhea = 9,
    TeenagePregnancy = 10,
    UnattendedYard = 11,
    DirtyYard = 12,
    Obstacles = 13,
    DirtyAnimals = 14,
    UnsatisfiedFarm = 15,
    PositiveFeedback = 16,
    BurntoutProducer = 17,
    UnmarkedAnimals = 18,
    UnfitAnimals = 19,
    MoreDetails = 20,
    AnimalHandling = 21,
    Timetable = 22,
    PositiveFeedback2 = 23,
    Other = 24,
}

/** Emulates Snellman.Anelma3.Common.Domain.Enums.BovineAnnouncements.AnnouncementFlagsEnum. Please, make any changes also to Snellman.Anelma3.Common.Domain.Enums.BovineAnnouncements.AnnouncementFlagsEnum  */
export enum AnnouncementFlagsEnum {
    Unknown = 0,
    Deleted = 1,
    ProducerConfirmed = 2,
    SnellmanConfirmed = 4,
}

/** Emulates AnelmaContract:State. Please, make any changes also to Snellman.Scrive.API.Domain.Enums.Contract.AnelmaContractStatus */
export enum AnelmaContractStatusEnum {
    Unknown = 0,
    Draft = 1, // created
    Open = 2, // signing process initiated, waiting for producers
    StartSign = 3, // some producers signed
    ProducerSigned = 4, // producers signed, waiting for Snellman
    Signed = 5, // contract is signed by everyone

    Rejected = 6, // contract is rejected to sign by someone
    Terminated = 7, // contract is terminated
    Ended = 8, // contract is ended
}

/** Emulates Snellman.Anelma3.Common.Domain.Enums.Bovine.BovineSex.cs. Please, make any changes also to Snellman.Anelma3.Common.Domain.Enums.Bovine.BovineSex.cs */
export enum BovineSex {
    Bull = 0,
    Cow = 1,
    Unknown = 9
}